<template>
  <div class="navbar-fixed-content" style="padding-top:70px;">
    <my-account-header></my-account-header>
    <div class="myinfo-bottom">
      <div class="cnt">
        <my-side-menu></my-side-menu>

        <div class="myinfo-con">
          <div class="tabbable-line">
            <ul class="nav nav-tabs">
              <li :class="[showTab==0?'active':'']">
                <a
                  class="a-tab"
                  data-status="1"
                  data-toggle="tab"
                  id="tab_1"
                  aria-expanded="true"
                  @click="showAllClick()"
                >我的上传</a>
              </li>
              <li :class="[showTab==1?'active':'']">
                <a
                  class="a-tab"
                  data-status="2"
                  data-toggle="tab"
                  id="tab_2"
                  aria-expanded="false"
                  @click="showAchievementsClick()"
                >我的成果上传</a>
              </li>
              <li :class="[showTab==2?'active':'']">
                <a
                  class="a-tab"
                  data-status="3"
                  data-toggle="tab"
                  id="tab_3"
                  aria-expanded="false"
                  @click="showTimeClick()"
                >培训风采上传</a>
              </li>
            </ul>
          </div>
          <div class="tab-content">
            <div :class="[showTab==0?'tab-pane active':'tab-pane']" id="tab_2_1">
              <div class="div-zb" style="margin-top: 10px;">
                <div class="div-head">
                  <div class="div1" style="width:250px">名称</div>
                  <div class="div2" style="width: 250px;">所属项目</div>
                  <div class="div2" style="width:70px;">类型</div>
                  <div class="div2" style="width:70px;">大小</div>
                  <div class="div3" style=" width: 150px;">时间</div>
                  <div class="div6">操作</div>
                </div>
              </div>
              <div class="chenggouList">
                <div class="fitem" v-for="item in myUploadFileLists">
                  <span
                    class="filename"
                    style="width:250px;display: inline-block;text-indent: 20px;white-space: nowrap;overflow: hidden;vertical-align: middle;text-overflow: ellipsis;"
                  >
                    <span class="ftype pptx"></span>
                    {{item.fileName}}
                  </span>
                  <span
                    class="className"
                    style="width: 250px; display: inline-block;text-indent: 20px;white-space: nowrap;overflow: hidden;vertical-align: middle;text-overflow: ellipsis;"
                  >{{item.className}}</span>
                  <span
                    class="resType"
                    style="width:70px;display: inline-block;text-indent: 20px;white-space: nowrap;overflow: hidden;vertical-align: middle;text-overflow: ellipsis;"
                  >{{item.resType == 1 ? '风采' : '成果'}}</span>
                  <span
                    class="filesize"
                    style="width:70px;display: inline-block;text-indent: 20px;white-space: nowrap;overflow: hidden;vertical-align: middle;text-overflow: ellipsis;"
                  >{{parseFloat(item.fileSize/1024/1024).toFixed(2)}}M</span>
                  <span
                    class="time"
                    style=" width: 150px;display: inline-block;text-indent: 20px;white-space: nowrap;overflow: hidden;vertical-align: middle;text-overflow: ellipsis;"
                  >{{item.createTime | dateFormat("YYYY-MM-DD HH:mm")}}</span>
                  <a class="btn_down" :href="item.fileUrl">下载</a>
                  <a class="delete" @click="deleteFiles(item)">删除</a>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-md-12 loading-more"
                  v-if="query_data.MaxResultCount*query_data.PageIndex < query_data.totalCount"
                  @click="loadMyUploadFiles()"
                >加载更多</div>
              </div>
            </div>
            <!-- @change="uploadMyAchievements($event)" -->

            <div :class="[showTab==1?'tab-pane active':'tab-pane']" id="tab_2_2">
              <div class="chengguo">
                <div class="chengguo_upload">
                  <div class="h_title">培训成果上传</div>
                  <div id="chooseban">
                    <h2>
                      选择
                      <br />专业研修班级
                    </h2>
                    <select class="banselect" @change="classChange($event)" >
                      <option
                        v-for="item in myAllClassLists"
                        :value="item.classId"
                        :key="item.classId"
                      >{{item.name}}</option>
                    </select>
                  </div>
                  <h2
                    style="border-bottom: 1px solid #f8f8f8;text-indent: 40px; line-height: 55px;font-size: 14px;font-weight: bold;"
                  >选择成果文件</h2>
                  <div class="citem">
                    <div class="btn-p1">
                      <button id="uploaderfile" style="height:0">
                        <div class="qq-uploader-selector qq-uploader" qq-drop-area-text>
                          <input
                            title="file input"
                            type="file"
                            name="qqfile"
                            style="position: absolute; right: 0px; top: 0px; font-family: Arial; font-size: 118px; margin: 0px; padding: 0px; cursor: pointer; opacity: 0; height: 100%;width:100%;"
                            @change="uploadMyAchievements($event)"
                          />
                          <div
                            class="qq-upload-drop-area-selector qq-upload-drop-area"
                            qq-hide-dropzone
                            style="display: none;"
                          ></div>
                          <div
                            class="qq-upload-button-selector qq-upload-button"
                            style="position: relative; overflow: hidden; direction: ltr;"
                          >
                            <div>选择文件</div>
                          </div>

                          <span
                            class="qq-drop-processing-selector qq-drop-processing qq-hide"
                            style="display:none"
                          >
                            <span>Processing dropped files...</span>
                            <span
                              class="qq-drop-processing-spinner-selector qq-drop-processing-spinner"
                            ></span>
                          </span>
                        </div>
                      </button>
                      <span class="uploaderfile"></span>
                    </div>
                    <div class="rt">
                      <h2>
                        选择成果方案资料
                        <img src="/Images/new/wenhao.png" class="wenhao" />
                      </h2>
                      <div class="txt">文档格式：pdf，ppt，word格式，建议大小：100M以内</div>
                    </div>
                  </div>
                  <div class="filebox1" style v-show="uploadFileArr.length > 0">
                    <h2>成果方案资料</h2>
                    <div class="filelist1">
                      <div class="fitem ftitem" v-for="item in uploadFileArr">
                        <span class="filename">{{item.filename}}</span>
                        <span class="filesize">{{item.filesize}}K</span>
                        <a class="btn_down" :href="item.fileurl">下载</a>
                        <a class="btn_delete" @click="deleteReadyUploadFile(item)">删除</a>
                      </div>
                    </div>
                  </div>
                  <div class="opr">
                    <button id="submitFile" @click="relationFileClcik(0)">上传培训成果</button>
                  </div>
                </div>
              </div>
            </div>

            <div :class="[showTab==2?'tab-pane active':'tab-pane']" id="tab_2_3">
              <div class="chengguo">
                <div class="chengguo_upload">
                  <div class="h_title">培训风采上传</div>
                  <div id="chooseban">
                    <h2>
                      选择
                      <br />专业研修班级
                    </h2>
                    <select class="banselect" @change="classChange($event)">
                      <option
                        v-for="item in myAllClassLists"
                        :value="item.classId"
                        :key="item.classId"
                      >{{item.name}}</option>
                    </select>
                  </div>
                  <h2
                    style="border-bottom: 1px solid #f8f8f8;text-indent: 40px; line-height: 55px;font-size: 14px;font-weight: bold;"
                  >选择培训风采文件</h2>
                  <div class="citem">
                    <div class="btn-p1">
                      <button id="uploaderfile" style="height:0">
                        <div class="qq-uploader-selector qq-uploader" qq-drop-area-text>
                          <input
                            title="file input"
                            type="file"
                            name="qqfile"
                            style="position: absolute; right: 0px; top: 0px; font-family: Arial; font-size: 118px; margin: 0px; padding: 0px; cursor: pointer; opacity: 0; height: 100%;width:100%;"
                            @change="uploadMyAchievements($event)"
                          />
                          <div
                            class="qq-upload-drop-area-selector qq-upload-drop-area"
                            qq-hide-dropzone
                            style="display: none;"
                          ></div>
                          <div
                            class="qq-upload-button-selector qq-upload-button"
                            style="position: relative; overflow: hidden; direction: ltr;"
                          >
                            <div>选择文件</div>
                          </div>

                          <span
                            class="qq-drop-processing-selector qq-drop-processing qq-hide"
                            style="display:none"
                          >
                            <span>Processing dropped files...</span>
                            <span
                              class="qq-drop-processing-spinner-selector qq-drop-processing-spinner"
                            ></span>
                          </span>
                        </div>
                      </button>
                      <span class="uploaderfile"></span>
                    </div>
                    <div class="rt">
                      <h2>
                        选择培训风采文件
                        <img src="/Images/new/wenhao.png" class="wenhao" />
                        <span
                          class="desc"
                          style="display: none;"
                        >修改完善后的教学创新团队建设方案，根据模块化课程教学和1+X 证书制度推进的要求并借鉴德国教育职业标准开发路径、开发出课程标准以及与岗位（群）能力对应的课程模块，开发出新的教学模式下的教学评价方法</span>
                      </h2>
                      <div class="txt">文档格式：pdf，ppt，word格式，建议大小：100M以内</div>
                    </div>
                  </div>
                  <div class="filebox1" style v-show="uploadFileArr.length > 0">
                    <h2>培训风采文件</h2>
                    <div class="filelist1">
                      <div class="fitem ftitem" v-for="item in uploadFileArr">
                        <span class="filename">{{item.filename}}</span>
                        <span class="filesize">{{item.filesize}}K</span>
                        <a class="btn_down" :href="item.fileurl">下载</a>
                        <a class="btn_delete" @click="deleteReadyUploadFile(item)">删除</a>
                      </div>
                    </div>
                  </div>

                  <div class="opr">
                    <button id="submitFile" @click="relationFileClcik(1)">上传培训风采</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyAccountHeader from "@/layout/MyAccountHeader";
import MySideMenu from "@/layout/MySideMenu";
import comFun from "@/common/common";
export default {
  components: {
    MyAccountHeader,
    MySideMenu,
  },
  data() {
    return {
      query_data: {
        stopajax: !1,
        MaxResultCount: 10,
        PageIndex: 0,
        totalCount: 0,
        index: 0,
        SkipCount: 0,
      },
      formMessage: {
        qqfilename: "",
        qqtotalfilesize: "",
        qqfile: "",
      },
      relationForm: {
        ClassId: "",
        ResourcesIds: [],
        FileNames: [],
        ResType: null,
      },
      myUploadFileLists: [],
      myAllClassLists: [],
      uploadFileArr: [],
      courseLists: [],
      showTab: 0,
    };
  },
  filters: {
    dateFormat(dateStr, pattern = "") {
      var dt = new Date(dateStr);
      var yy = dt.getFullYear();
      var mm = (dt.getMonth() + 1).toString().padStart(2, "0");
      var dd = dt.getDate().toString().padStart(2, "0");
      var h = dt.getHours().toString().padStart(2, "0");
      var m = dt.getMinutes().toString().padStart(2, "0");
      var s = dt.getSeconds().toString().padStart(2, "0");
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return yy + "-" + mm + "-" + dd;
      } else if (pattern.toLowerCase() === "yyyy-mm-dd hh:mm") {
        return yy + "-" + mm + "-" + dd + " " + h + ":" + m;
      } else if (pattern.toLowerCase() === "hh:mm") {
        return h + ":" + m;
      } else {
        return yy + "-" + mm + "-" + dd + " " + h + ":" + m + ":" + s;
      }
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    nav() {
      return this.$store.state.nav;
    },
  },

  mounted() {
    // this.loadMore()
    this.loadMyUploadFiles();
    this.loadMyAllClass();
  },
  methods: {
    loadMyUploadFiles: function () {
      comFun.getMyUploadFileLists(this.query_data).then((res) => {
        this.myUploadFileLists = this.myUploadFileLists.concat(
          res.result.items
        );
        this.query_data.totalCount = res.result.totalCount;
        if (
          this.query_data.PageIndex * this.query_data.MaxResultCount <
          this.query_data.totalCount
        ) {
          this.query_data.PageIndex = this.query_data.PageIndex+1 ;
        } else {
          this.query_data.stopajax = 1;
        }
      });
    },
    loadMyAllClass: function () {
      comFun.getMyAllClass().then((res) => {
        this.myAllClassLists = res.result;
      });
    },
    showAllClick: function () {
      this.showTab = 0;
    },
    showAchievementsClick: function () {
      this.showTab = 1;
    },
    showTimeClick: function () {
      this.showTab = 2;
    },
    uploadMyAchievements: function (e) {
      var file = e.target.files[0];
      this.relationForm.FileNames = this.relationForm.FileNames.concat(
        file.name
      );
      this.formMessage.qqtotalfilesize = file.size;
      this.formMessage.qqfilename = file.name;
      this.formMessage.qqfile = file;

      const formData = new FormData();
      Object.keys(this.formMessage).forEach((key) => {
        formData.append(key, this.formMessage[key]);
      });

      comFun.uploaderMyAchievement(formData).then((res) => {
        var uploadFileData = {};
        uploadFileData.filename = res.result.fileName;
        uploadFileData.filesize = res.result.fileSize;
        uploadFileData.fileurl = res.result.fileUrl;
        this.uploadFileArr.push(uploadFileData);
        this.relationForm.ResourcesIds.push(res.result.resourceId);
      });
    },
    classChange(e) {
      this.relationForm.ClassId = e.target.value;
    },
    relationFileClcik: function (t) {
      if (t == 1) {
        this.relationForm.ResType = 1;
      } else if (t == 0) {
        this.relationForm.ResType = 0;
      }
      //成果上传
      if (!this.relationForm.ClassId) {
        this.relationForm.ClassId = this.myAllClassLists[0].classId;
      }
      const formData = new FormData();
      Object.keys(this.relationForm).forEach((key) => {
        formData.append(key, this.relationForm[key]);
      });
      comFun.relationFileWithClaass(formData).then((res) => {
        if (res.success == true) {
          var msg = {
            type: "success",
            text: "文件上传成功",
          };
          this.$store.dispatch("setMsg", msg);
          this.uploadFileArr = [];
          this.relationForm = {};
          this.showTab = 0;
          this.$router.go(0);
        }
      });
    },
    deleteFiles(item) {
      comFun.deleteMyUploadFile(item.fileId).then((res) => {
        if (res.result == true) {
          this.myUploadFileLists = this.myUploadFileLists.filter(function (
            ele
          ) {
            return ele != item;
          });
          var msg = {
            type: "success",
            text: "文件删除成功",
          };
          this.$store.dispatch("setMsg", msg);
        }
      });
    },
    deleteReadyUploadFile(item) {
      this.uploadFileArr = this.uploadFileArr.filter(function (ele) {
        return ele != item;
      });
    },
  },
};
</script>